import openSocket from "socket.io-client";
import { messagePath } from "constants.js";
const socket = openSocket(messagePath, {
  path: "/message/", // or "/message/" if your server expects trailing slash
  transports: ["websocket"], // optional but enforces WebSocket-only
});

export function subscribeToTimer(cb) {
  socket.on("timer", timestamp => cb(null, timestamp));
  socket.emit("subscribeToTimer", 1000);
}

export function subscribeToClientMessaging(brokerId, clientId, token) {
  socket.on("JOINED", data => {
    socket.emit(`subscribe/client_messaging/${brokerId}+${clientId}`);
  });
  socket.emit("subscribe/client_messaging", { brokerId, clientId, token });
}

export function sendClientMessage(message, senderId, comboRoute) {
  socket.emit(`${comboRoute}/message`, message, senderId);
}

export function listenToClientMessages(comboRoute, callBack) {
  socket.on(`${comboRoute}/message`, data => {
    callBack(data);
  });
}

export function RemoveMessageListeners(comboRoute) {
  socket.removeAllListeners(`${comboRoute}`);
  socket.removeAllListeners(`${comboRoute}/message`);
  socket.removeAllListeners("JOINED");
  socket.emit("removeMessageListeners", comboRoute);
}



// WEBPACK FOOTER //
// ./src/sockets/api.js